import { VendorErrorCategory } from '@evimo/types/enums/vendor-error-category';
import { VendorErrorImpactedComponent } from '@evimo/types/enums/vendor-error-impacted-component';
import { VendorErrorParameter } from '@evimo/types/enums/vendor-error-parameter';
import { VendorErrorSeverity } from '@evimo/types/enums/vendor-error-severity';
import { VendorErrorState } from '@evimo/types/enums/vendor-error-state';
import type { SelectOption } from '~/app/components/errorManagement/ErrorManagementPage/types';

function toOptions(values: Record<string, string>): SelectOption[] {
  return Object.values(values).map((value) => ({ label: value, value }));
}

export function useVendorErrorCodeEnumOptions(): {
  parameterOptions: SelectOption[];
  stateOptions: SelectOption[];
  impactedComponentOptions: SelectOption[];
  categoryOptions: SelectOption[];
  severityOptions: SelectOption[];
} {
  return {
    parameterOptions: toOptions(VendorErrorParameter),
    stateOptions: toOptions(VendorErrorState),
    impactedComponentOptions: toOptions(VendorErrorImpactedComponent),
    categoryOptions: toOptions(VendorErrorCategory),
    severityOptions: toOptions(VendorErrorSeverity),
  };
}
